import React from "react";

import { queries } from "lib/build/dashboards/basic-health/queries";

import { useEventsByQuery } from "src/features/events";
import { BmiTrendChart } from "src/features/stats";
import { useSectionList } from "src/modules/basic-health/dashboard/useSectionList";
import {
	filterSectionList,
	Search,
	SectionList
} from "src/modules/shared/dashboard";

export const Dashboard: React.FunctionComponent = () => {
	const [query, setQuery] = React.useState("");
	const sections = useSectionList();
	const filteredSections = React.useMemo(
		() => filterSectionList(sections, query),
		[sections, query]
	);
	return (
		<>
			<Search query={query} onChangeQuery={setQuery} />
			<BmiTrendChartRenderer />
			<SectionList sections={filteredSections} />
		</>
	);
};

const BmiTrendChartRenderer: React.FunctionComponent = () => {
	const events = useEventsByQuery<number>(queries.bmi);
	return <BmiTrendChart events={events} />;
};
